<template>
	<div class="sections">
		<div class="section section--bordered section--full">
			<h2 class="beta">Estimate</h2>
			c
		</div>
		<div class="section section--bordered section--full">
			<h2 class="beta" v-html="comparison.quote ? 'Service Providers' : 'Comparison'"/>
			<table class="comparison--conveyancing mt-1">
				<thead>
					<tr>
						<th align="left">Conveyancer</th>
						<template v-if="!comparison.quote">
							<th align="center">Legal Fees</th>
							<th align="center">Legal Fees VAT</th>
							<th align="center">Fees</th>
							<th align="center">Fees VAT</th>
							<th align="center">Disbursements</th>
							<th align="center">Total</th>
						</template>
						<th
							v-if="!comparison.introduction || comparison.introduction.opt_in" align="right"
							class="actions">
							<span>Action</span></th>
					</tr>
				</thead>
				<tbody class="comparison--quoted">
					<tr
						v-for="(serviceProvider, serviceProviderIndex) in comparison.serviceProviders"
						:class="classObject(serviceProvider)"
						class="comparison__quote">
						<td v-html="serviceProvider.profile.name"/>
						<template v-if="!comparison.quote">
							<td align="center" class="subtotal"><span
								class="price"
								v-html="$present('price', serviceProvider.pivot.quote.calculation.legalFeesSubTotal)"/>
							</td>
							<td align="center" class="tax"><span
								class="price"
								v-html="$present('price', serviceProvider.pivot.quote.calculation.legalFeesTax)"/>
							</td>
							<td align="center" class="subtotal"><span
								class="price"
								v-html="$present('price', serviceProvider.pivot.quote.calculation.feesSubTotal)"/>
							</td>
							<td align="center" class="tax"><span
								class="price"
								v-html="$present('price', serviceProvider.pivot.quote.calculation.feesTax)"/>
							</td>
							<td align="center" class="disbursements"><span
								class="price"
								v-html="$present('price', serviceProvider.pivot.quote.calculation.disbursementsSubTotal)"/>
							</td>
							<td align="center" class="total">
								<span v-html="$present('price', serviceProvider.pivot.quote.calculation.total)"/>
								<button
									class="button button--secondary--small"
									@click="showBreakdown(serviceProvider.pivot.quote)">Breakdown
								</button>
							</td>
						</template>
						<td v-if="!comparison.introduction || comparison.introduction.opt_in" align="right">
							<process-button
								v-if="!instructed(serviceProvider)" :processing="instructing(serviceProvider)"
								class="button button--primary--small" text="Instruct"
								@click="instruct(serviceProvider)"/>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {
			serviceProvider: null,
		};
	},

	props: {
		comparison: {
			type: Object,
			required: true,
		},
	},

	methods: {
		classObject(serviceProvider) {
			return {
				"comparison__quote--instructed": this.comparison.active_instruction
					&& serviceProvider.pivot.instruction
					&& serviceProvider.pivot.instruction.id === this.comparison.active_instruction.id,
			};
		},
		showBreakdown(quote) {
			this.$vmodal.open({
				component: require("./QuoteBreakdownConveyancing.vue").default,
				props: {
					quote: quote,
				},
			});
		},
		instructed(serviceProvider) {
			return this.comparison.active_instruction
				&& serviceProvider.pivot.instruction
				&& serviceProvider.pivot.instruction.id === this.comparison.active_instruction.id;
		},
		instructing(serviceProvider) {
			return this.serviceProvider && this.serviceProvider.id === serviceProvider.id;
		},
		instruct(serviceProvider) {
			this.serviceProvider = serviceProvider;
			this.$emit("instructing");
			let api = this.$authed()
				? http()
				: this.$client("client");
			api.post("comparisons/" + this.comparison.id + "/service-providers/" + serviceProvider.id + "/instruct").then(response => {
				console.log("response", response, response.data);
				this.serviceProvider = null;
				this.$emit("instructed", response.data);
			});
		},
	},
};
</script>
